"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var Styled = _interopRequireWildcard(require("./ToggleSwitch.styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ToggleSwitch = function ToggleSwitch(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      label = _ref.label,
      onChange = _ref.onChange,
      validations = _ref.validations,
      value = _ref.value;

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onChange'
  }),
      errors = _getFormMethods.errors,
      register = _getFormMethods.register;

  var fieldErrors = error || errors[id];
  var required = (0, _get["default"])(validations, 'required');

  var _useState = (0, _react.useState)(checked || false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      checkedStatus = _useState2[0],
      setCheckedStatus = _useState2[1];

  var handleCheckboxChange = function handleCheckboxChange(event) {
    setCheckedStatus(event.target.checked);

    if (onChange) {
      onChange(event);
    }
  };

  (0, _react.useEffect)(function () {
    setCheckedStatus(checked);
  }, [checked, setCheckedStatus]);
  return /*#__PURE__*/_react["default"].createElement(Styled.ToggleSwitchContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Styled.Checkbox, {
    type: "checkbox",
    id: id,
    name: id,
    checked: checkedStatus,
    onChange: handleCheckboxChange,
    ref: register(validations),
    value: value
  }), /*#__PURE__*/_react["default"].createElement(Styled.LabelContainer, null, /*#__PURE__*/_react["default"].createElement(Styled.SwitchBackground, {
    background: checkedStatus,
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(Styled.SwitchDot, {
    checkedStatus: checkedStatus
  })), /*#__PURE__*/_react["default"].createElement(Styled.SwitchLabel, {
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(Styled.Labeltext, null, label, required && /*#__PURE__*/_react["default"].createElement(Styled.SwitchRequired, {
    disabled: disabled
  }, "*")))), fieldErrors && /*#__PURE__*/_react["default"].createElement(Styled.SwitchError, null, fieldErrors.message));
};

ToggleSwitch.propTypes = {
  /* is toggle value checked */
  checked: _propTypes.bool,

  /* custom class name, lets you use as a styled component */
  className: _propTypes.string,

  /** Disabled state */
  disabled: _propTypes.bool,

  /** For passing external errors to the component */
  error: (0, _propTypes.shape)({
    message: _propTypes.string
  }),

  /* id of the toggle */
  id: _propTypes.string,

  /** The toggle label */
  label: _propTypes.string,

  /** Function to trigger when toggle state is updated */
  onChange: _propTypes.func,

  /** React-Hook-Forms Validations to be provided for the component. */
  validations: (0, _propTypes.shape)({
    required: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string]),
    validate: (0, _propTypes.shape)({})
  }),

  /** The input value */
  value: (0, _propTypes.oneOfType)([_propTypes.bool, _propTypes.string, _propTypes.number])
};
ToggleSwitch.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  error: undefined,
  id: 'toggleSwitch',
  label: undefined,
  onChange: null,
  validations: null,
  value: undefined
};
ToggleSwitch.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ToggleSwitch",
  "props": {
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Disabled state",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "error": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "For passing external errors to the component",
      "type": {
        "name": "shape",
        "value": {
          "message": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "'toggleSwitch'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "label": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The toggle label",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Function to trigger when toggle state is updated",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "validations": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "React-Hook-Forms Validations to be provided for the component.",
      "type": {
        "name": "shape",
        "value": {
          "required": {
            "name": "union",
            "value": [{
              "name": "bool"
            }, {
              "name": "string"
            }],
            "required": false
          },
          "validate": {
            "name": "shape",
            "value": {},
            "required": false
          }
        }
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The input value",
      "type": {
        "name": "union",
        "value": [{
          "name": "bool"
        }, {
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    }
  }
};
var _default = ToggleSwitch;
exports["default"] = _default;